// firmenAnzeige.ts — Unternehmen eines geschäftlichen Kommunikationswegs als
// kurzer Text (User 02.10.2026):
//
//   eine Firma      → „Firma 1"
//   zwei Firmen     → „Firma 1 und Firma 2"
//   mehr            → „Firma 1, Firma 2, +x"
//   zu lang         → „Firma 1, weitere"
//   schon der erste
//   Name zu lang    → „Firma 1 …" (gekürzt)
//
// Der volle Text („Firma 1, Firma 2 und Firma 3") gehört in den Tooltip.
// Gemessen wird in Zeichen, nicht in Pixeln: Der Text steht klein und grau im
// Feld-Label, die Grenze ist eine Lesbarkeits-, keine Layoutfrage.

/** Standard-Grenze für den grauen Firmentext im Feld-Label. */
export const FIRMEN_TEXT_MAX = 40;

/** „A", „A und B", „A, B und C" — die vollständige Aufzählung. */
export function firmenVoll(namen: readonly string[]): string {
  const n = namen.map((s) => s.trim()).filter(Boolean);
  if (n.length <= 1) return n[0] ?? "";
  return `${n.slice(0, -1).join(", ")} und ${n[n.length - 1]}`;
}

/** Gekürzte Anzeige plus voller Text für den Tooltip. Leere Liste → beide leer. */
export function firmenAnzeige(
  namen: readonly string[],
  max: number = FIRMEN_TEXT_MAX,
): { text: string; voll: string } {
  const n = namen.map((s) => s.trim()).filter(Boolean);
  const voll = firmenVoll(n);
  if (!n.length) return { text: "", voll: "" };

  const passt = (s: string) => s.length <= max;
  const erster = (zusatz: string): string => {
    // „Firma 1 …": so viel vom ersten Namen, wie neben dem Zusatz Platz hat.
    const platz = Math.max(1, max - zusatz.length);
    return `${n[0].slice(0, platz).trimEnd()}${zusatz}`;
  };

  if (n.length === 1) {
    return { text: passt(n[0]) ? n[0] : erster(" …"), voll };
  }
  const kandidat = n.length === 2 ? `${n[0]} und ${n[1]}` : `${n[0]}, ${n[1]}, +${n.length - 2}`;
  if (passt(kandidat)) return { text: kandidat, voll };
  const weitere = `${n[0]}, weitere`;
  if (passt(weitere)) return { text: weitere, voll };
  return { text: erster(" …"), voll };
}
